// Put this in its own file to make it easier to deal with globally.
// It seems that Chrome used to not understand "autoComplete=off".
// See https://stackoverflow.com/questions/15738259/disabling-chrome-autofill/15917221

export const autoCompleteOff = {
  autoComplete: 'off'
}
